import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { useTranslate } from '../util';
import { StyledNoResults, StyledResults, StyledResultsList, StyledResultsListItem } from './ResultsList.styled';
export function ResultsList(props) {
  var t = useTranslate();
  if ((!props.input || props.isSearching) && !props.results.length && !props.children) {
    return null;
  }
  var wrapperStyle = {
    maxWidth: props.maxWidth
  };
  return /*#__PURE__*/React.createElement(StyledResults, {
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(StyledResultsList, props.getMenuProps({}), props.results.map(function (item, index) {
    return /*#__PURE__*/React.createElement(StyledResultsListItem, _extends({
      key: "".concat(props.itemToString(item)).concat(index),
      highlight: props.highlightedIndex === index
    }, props.getItemProps({
      index: index,
      item: item,
      title: props.itemToString(item)
    })), props.itemToString(item));
  }), props.input && !props.results.length && !props.isSearching && /*#__PURE__*/React.createElement(StyledNoResults, null, props.noResultsText || t('citrix-ui:typeahead.no_results'))), props.children);
}